import logger from "../utils/logger";
import { RoleConstants } from "../utils/constants";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
export const saveUser = user => {
  if (!user) {
    logger.warn("Attempting to save null user");
    return;
  }

  // Clear debug skip flags on new login
  localStorage.removeItem("debug_skip_payment_setup");
  localStorage.removeItem("debug_skip_subscription");

  localStorage.setItem("currentUser", JSON.stringify(user));

  // Save tokens to localStorage
  if (user.access_token) {
    localStorage.setItem("access_token", user.access_token);
  }
  if (user.refresh_token) {
    localStorage.setItem("refresh_token", user.refresh_token);
  }
  // Backward compatibility for old token field
  if (user.token) {
    localStorage.setItem("authToken", user.token);
  }
};

export const getUser = () => {
  try {
    const user = localStorage.getItem("currentUser");
    if (!user) return null;

    return JSON.parse(user);
  } catch (error) {
    logger.error("Error parsing user data from localStorage:", error);
    // Clear invalid data
    localStorage.removeItem("currentUser");
    return null;
  }
};

export const getAuthToken = () => {
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    return accessToken;
  }
  const token = localStorage.getItem("authToken");
  return token;
};

export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    logger.log(`Saved ${key} to localStorage:`, value);
  } catch (error) {
    logger.error(`Error saving ${key} to localStorage:`, error);
  }
};

export const getItem = key => {
  try {
    const value = localStorage.getItem(key);
    logger.log(`Retrieved ${key} from localStorage:`, value);
    return value;
  } catch (error) {
    logger.error(`Error retrieving ${key} from localStorage:`, error);
    return null;
  }
};

export const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refresh_token");
  return refreshToken;
};

export const saveListingData = async data => {
  try {
    localStorage.setItem("listingData", JSON.stringify(data));
  } catch (e) {
    logger.log("Error saving listing data");
  }
};

export const clearListingData = () => {
  try {
    localStorage.removeItem("listingData");
  } catch (e) {
    logger.log("an error occurred while removing listing data");
  }
};

export const getListingData = () => {
  try {
    return JSON.parse(localStorage.getItem("listingData"));
  } catch (e) {
    logger.log("An error occurred while parsing string to json");
  }
};

export const getCurrency = () => {
  try {
    const stored = localStorage.getItem("userCurrency");
    if (stored) {
      return JSON.parse(stored);
    }
    return null;
  } catch (e) {
    logger.log("An error occurred while parse string to json.");
    return null;
  }
};

export const setCurrency = data => {
  try {
    localStorage.setItem("userCurrency", JSON.stringify(data));
    // Trigger storage event for cross-tab/component sync
    window.dispatchEvent(new Event("currencyChanged"));
  } catch (e) {
    logger.log("An error occurred while parse string to json.");
  }
};

export const newProperty = () => {
  try {
    localStorage.getItem("newProperty");
    logger.log(localStorage.getItem("newProperty"));
  } catch (e) {
    logger.log("An error occurred while parse string to json.");
  }
};

export const setnewProperty = data => {
  try {
    logger.log(data);
    localStorage.setItem("newProperty", data);
    logger.log("Item set to true");
  } catch (e) {
    logger.log("An error occurred while parse string to json.");
  }
};

export const setCompanyId = data => {
  try {
    localStorage.setItem("companyId", JSON.stringify(data));
  } catch (e) {
    logger.log("An error occurred while parse string to json.");
  }
};

export const getCompanyId = () => {
  try {
    return JSON.parse(localStorage.getItem("companyId"));
  } catch (e) {
    logger.log("An error occurred while parse string to json.");
  }
};

// confirm order response
export const setConfirmOrderResponse = data => {
  try {
    localStorage.setItem("confirmOrderResponse", JSON.stringify(data));
  } catch (e) {
    logger.log("ERROR SAVING CONFIRM ORDER RESPONSE: ", e);
  }
};

export const getConfirmOrderResponse = () => {
  try {
    return JSON.parse(localStorage.getItem("confirmOrderResponse"));
  } catch (e) {
    logger.log("ERROR GETTING CONFIRM ORDER RESPONSE: ", e);
  }
};

export const saveActiveSubscription = subscription => {
  if (!subscription) {
    logger.warn("Attempting to save null subscription");
    return;
  }
  localStorage.setItem("activeSubscription", JSON.stringify(subscription));
  logger.log("Saved active subscription to localStorage:", subscription);
};

export const getActiveSubscription = () => {
  try {
    const subscription = localStorage.getItem("activeSubscription");
    if (!subscription) return null;

    const parsedSubscription = JSON.parse(subscription);
    logger.log("Retrieved active subscription from localStorage:", parsedSubscription);
    return parsedSubscription;
  } catch (error) {
    logger.error("Error parsing subscription data from localStorage:", error);
    // Clear invalid data
    localStorage.removeItem("activeSubscription");
    return null;
  }
};

export const clearActiveSubscription = () => {
  localStorage.removeItem("activeSubscription");
  logger.log("Cleared active subscription from localStorage");
};

export const clearAllUserData = () => {
  // Save account metadata before clearing (for multi-account support)
  const savedAccounts = localStorage.getItem("saved_accounts");

  localStorage.removeItem("currentUser");
  localStorage.removeItem("authToken");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("activeSubscription");
  localStorage.removeItem("listingData");
  localStorage.removeItem("userCurrency");
  localStorage.removeItem("newProperty");
  localStorage.removeItem("companyId");
  localStorage.removeItem("confirmOrderResponse");
  localStorage.removeItem("debug_skip_payment_setup");
  localStorage.removeItem("debug_test_country"); // Clear debug test country
  // Clear any cart related data
  localStorage.removeItem("cartDetails");
  // Clear Redux persist storage - CRITICAL for proper logout
  localStorage.removeItem("persist:root");
  // Clear cached search parameters and dates on logout
  localStorage.removeItem("searchFilters");
  localStorage.removeItem("searchDates");

  // Reset PostHog user session on logout
  try {
    const posthogModule = require("../utils/posthog");
    posthogModule.resetUser();
  } catch (e) {}

  // Clear any token refresh intervals
  if (typeof window !== "undefined" && window.tokenRefreshInterval) {
    clearInterval(window.tokenRefreshInterval);
    window.tokenRefreshInterval = null;
  }

  // Clear session monitoring
  clearSessionMonitoring();

  // Restore saved accounts (preserve for multi-account support)
  if (savedAccounts) {
    localStorage.setItem("saved_accounts", savedAccounts);
  }

  logger.log("Cleared all user data from localStorage including Redux persist (preserved saved accounts)");
};

/**
 * Check if access token is expired or about to expire
 * @returns {boolean} True if token needs refresh
 */
export const shouldRefreshToken = () => {
  try {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return true;

    // Decode JWT token to check expiration
    const payload = JSON.parse(atob(accessToken.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);

    const timeUntilExpiry = payload.exp - currentTime;
    return timeUntilExpiry < 300; // Refresh if token expires in the next 5 minutes
  } catch (error) {
    logger.error("Error checking token expiry:", error);
    return true;
  }
};

/**
 * Get token expiry time in seconds
 * @returns {number|null} Expiry time in seconds or null if invalid
 */
export const getTokenExpiryTime = () => {
  try {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return null;

    const payload = JSON.parse(atob(accessToken.split(".")[1]));
    return payload.exp;
  } catch (error) {
    logger.error("Error getting token expiry time:", error);
    return null;
  }
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user has valid tokens
 */
export const isAuthenticated = () => {
  const accessToken = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  const currentUser = localStorage.getItem("currentUser");

  return !!(accessToken && refreshToken && currentUser);
};

/**
 * Check if token has expired and handle automatic logout
 * @returns {boolean} True if token is expired and user was logged out
 */
export const checkTokenExpiryAndLogout = () => {
  try {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      // No token found, user is not authenticated
      return false;
    }

    // Decode JWT token to check expiration
    const payload = JSON.parse(atob(accessToken.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);

    // Check if token has expired
    if (payload.exp < currentTime) {
      logger.warn("Token has expired, logging out user automatically");

      // Clear all user data
      clearAllUserData();

      // Redirect to login page only if not on public pages
      const publicPages = [
        "/home",
        "/signin",
        "/auth/signin",
        "/signup",
        "/host-experience",
        "/report-issue",
        "/corporate-page",
        "/terms-of-use",
        "/privacy-policy",
      ];
      if (!publicPages.includes(window.location.pathname)) {
        window.location.href = "/signin";
      }

      return true;
    }

    return false;
  } catch (error) {
    logger.error("Error checking token expiry for logout:", error);
    // If we can't decode the token, it's likely invalid, so logout
    clearAllUserData();
    const publicPages = [
      "/home",
      "/signin",
      "/auth/signin",
      "/signup",
      "/host-experience",
      "/report-issue",
      "/corporate-page",
      "/terms-of-use",
      "/privacy-policy",
    ];
    if (!publicPages.includes(window.location.pathname)) {
      window.location.href = "/signin";
    }
    return true;
  }
};

/**
 * Set up session monitoring to automatically logout when token expires
 * @param {number} checkInterval - Interval in milliseconds to check token expiry (default: 30 seconds)
 */
export const setupSessionMonitoring = (checkInterval = 30000) => {
  // Clear any existing session monitoring
  if (window.sessionMonitoringInterval) {
    clearInterval(window.sessionMonitoringInterval);
  }

  // Set up interval to check token expiry
  window.sessionMonitoringInterval = setInterval(() => {
    const wasLoggedOut = checkTokenExpiryAndLogout();
    if (wasLoggedOut) {
      // Clear the interval since user is logged out
      clearInterval(window.sessionMonitoringInterval);
      window.sessionMonitoringInterval = null;
    }
  }, checkInterval);

  logger.log(`Session monitoring set up with ${checkInterval}ms interval`);
};

/**
 * Clear session monitoring interval
 */
export const clearSessionMonitoring = () => {
  if (window.sessionMonitoringInterval) {
    clearInterval(window.sessionMonitoringInterval);
    window.sessionMonitoringInterval = null;
    logger.log("Session monitoring cleared");
  }
};

/**
 * Utility function to manually test session expiry (for development/testing)
 * This function artificially expires the token by setting a past expiry time
 */
export const testSessionExpiry = () => {
  try {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      logger.warn("No access token found for testing");
      return;
    }

    // Decode the token
    const parts = accessToken.split(".");
    const payload = JSON.parse(atob(parts[1]));

    // Set expiry to 1 hour ago
    payload.exp = Math.floor(Date.now() / 1000) - 3600;

    // Re-encode the token
    const newPayload = btoa(JSON.stringify(payload));
    const newToken = `${parts[0]}.${newPayload}.${parts[2]}`;

    // Replace the token
    localStorage.setItem("access_token", newToken);

    logger.log("Token artificially expired for testing");

    // Trigger immediate check
    checkTokenExpiryAndLogout();
  } catch (error) {
    logger.error("Error testing session expiry:", error);
  }
};

/**
 * Check if user should see host experience based on their role
 * @returns {boolean} True if user should see host experience
 */
export const shouldSeeHostExperience = () => {
  try {
    const user = getUser();
    if (!user) return false;

    const userRole = user?.organizationRole?.code || user?.role || "";
    const org = user.organization || {};
    const _orgTypeCode = org.typeCode || org.code || org.type?.code || "";
    const _orgTypeId = org.typeId || org.id || org.type?.id;

    // Check if role contains "HOST" (case insensitive)
    const roleHasHost = userRole.toLowerCase().includes("host");

    // Use centralized role system to check if user should see host experience
    const hasHostRole = RoleConstants.isRoleInGroup(userRole, "HOST_EXPERIENCE_ROLES");

    // Return true if any condition is met
    return roleHasHost || hasHostRole;
  } catch (error) {
    logger.error("Error checking if user should see host experience:", error);
    return false;
  }
};

/**
 * Get the appropriate redirect path for a user based on their role
 * @returns {string} The redirect path
 */
export const getRedirectPathForUser = () => {
  try {
    const user = getUser();
    if (!user) return "/home";

    const userRole = user?.organizationRole?.code || user?.role || "";

    // Use centralized role navigation system
    return RoleConstants.getNavigationPath(userRole);
  } catch (error) {
    logger.error("Error getting redirect path for user:", error);
    return "/dashboard";
  }
};

/**
 * Get or generate a unique device ID for the current browser/installation
 * Uses browser fingerprinting for a stable ID that persists across cache clears.
 * @returns {Promise<string>} Unique device ID
 */
export const getDeviceId = async () => {
  try {
    // 1. Check if we have a cached deviceId in localStorage for performance
    let deviceId = localStorage.getItem("deviceId");
    if (deviceId) {
      return deviceId;
    }

    // 2. If not in cache, calculate the fingerprint
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    deviceId = result.visitorId;

    // 3. Cache the ID for future synchronous-like lookup (performance)
    localStorage.setItem("deviceId", deviceId);
    logger.log("Generated new deviceId using fingerprinting:", deviceId);

    return deviceId;
  } catch (error) {
    logger.error("Error managing deviceId:", error);
    // Fallback to random ID if fingerprinting fails
    return `fp-fallback-${Math.random().toString(36).substring(2, 11)}`;
  }
};
